<template>
  <div class="item mb-2" :class="{current: isCurrent}">
    <div class="contact" v-text="contactLine"></div>
    <div class="outgoing-number" v-text="outgoingNumberLine"></div>
  </div>
</template>

<script>
import {isFilled} from "../../../../helpers";

export default {
  props: {
    item: null,
    isCurrent: null,
    select: null,
  },

  computed: {
    /**
     * @return {Object|null}
     */
    contact() {
      return _.get(this.item, 'conversation.contact', null);
    },

    /**
     * @return {Object|null}
     */
    outgoingNumber() {
      return _.get(this.item, 'conversation.outgoing_number', null);
    },

    /**
     * @return {string}
     */
    contactLine() {
      const {full_name, filemaker_id, phone_number} = this.contact || {};

      return `${filemaker_id} ${full_name}`
        + (isFilled(phone_number) ? ` (${phone_number})` : '');
    },

    /**
     * @return {string}
     */
    outgoingNumberLine() {
      const {title, phone_number} = this.outgoingNumber || {};
      return `${title} (${phone_number})`;
    },
  },

  methods: {
    // ...
  },
}
</script>

<style scoped>

</style>
